import React from 'react';
import { AreaField, Button, FlexRow, Grid, ModalWindow, SwitchDialogWindows } from 'ui-toolkit';
import { Form, Formik } from 'formik';
import { faClock } from '@fortawesome/pro-regular-svg-icons';
import { WarningIcon } from '../../shared/WarningIcon';
import { cancelOrderSchema } from '../../../ui-toolkit/orders/components/CancelOrder/cancelOrderSchema';
interface ICancelOrderProps {
  isOrderAutoCancelable: boolean;
  onCancelOrder: (message: string) => void;
  onClose: () => void;
}

export const CancelOrderDialogWindows: React.FC<ICancelOrderProps> = ({
  onCancelOrder,
  onClose,
  isOrderAutoCancelable,
}) => {
  const successIcon = isOrderAutoCancelable && <WarningIcon icon={faClock} />;
  const successTitle = isOrderAutoCancelable ? 'Request Received' : 'Order cancelled';
  const successMessage =
    isOrderAutoCancelable &&
    'Due to the status of this order, we need to take a few precautionary steps before proceeding to cancel.';
  return (
    <Formik
      initialValues={{ reason: '' }}
      onSubmit={(values) => onCancelOrder(values.reason)}
      onReset={onClose}
      validateOnMount
      validationSchema={cancelOrderSchema(true)}
    >
      {({ isValid, dirty, values }) => (
        <Form>
          <SwitchDialogWindows
            isLoading={false}
            isCompleted={false}
            isError={false}
            onCloseClick={onClose}
            onRetryClick={() => onCancelOrder(values.reason)}
            successMessage={successMessage}
            successTitle={successTitle}
            successIcon={successIcon}
          >
            <ModalWindow title={'Why would you like to cancel this order?'} onClose={onClose}>
              <Grid>
                <AreaField
                  name={'reason'}
                  placeholder={'Cancellation Reason'}
                  rows={1}
                  hintText={`${values.reason?.length || 0}/50 Characters Remaining`}
                />
                <FlexRow justifyContent={'flex-end'}>
                  <FlexRow>
                    <Button intent={'ghost'} isInline type={'reset'}>
                      Cancel
                    </Button>
                    <Button
                      intent={'primary'}
                      type={'submit'}
                      disabled={(!isValid && !dirty)}
                    >
                      Confirm
                    </Button>
                  </FlexRow>
                </FlexRow>
              </Grid>
            </ModalWindow>
          </SwitchDialogWindows>
        </Form>
      )}
    </Formik>
  );
};
